import VNavigationDrawer from './VNavigationDrawer'

/* istanbul ignore next */
VNavigationDrawer.install = function install (Vue) {
  Vue.component(VNavigationDrawer.name, VNavigationDrawer)
}

export default VNavigationDrawer



// WEBPACK FOOTER //
// ./src/components/VNavigationDrawer/index.js